import { formatTime } from '../../utils/Shipment';
const { REACT_APP_API, REACT_APP_API_SECURE } = process.env;
export const columns = t => {
  return [
    {
      title: t('Number'),
      name: 'id'
    },
    {
      title: t('Pickup ZIP'),
      name: 'originZip',
      sortName: 'originPostalCode'
    },
    {
      title: t('Pickup City'),
      name: 'originCity'
    },
    {
      title: t('Delivery ZIP'),
      name: 'destinationZip',
      sortName: 'destinationPostalCode'
    },
    {
      title: t('Delivery City'),
      name: 'destinationCity'
    },
    {
      title: t('Pickup Date'),
      name: 'pickupDate'
    },
    {
      title: t('Planned Pickup'),
      name: 'plannedPickup'
    },
    {
      title: t('Projected Pickup'),
      name: 'projectedPickup'
    },
    {
      title: t('Actual Pickup'),
      name: 'actualPickup'
    },
    {
      title: t('Delivery Date'),
      name: 'deliveryDate'
    },
    {
      title: t('Planned Delivery'),
      name: 'plannedDelivery'
    },
    {
      title: t('Projected Delivery'),
      name: 'projectedDelivery'
    },
    {
      title: t('Actual Delivery'),
      name: 'actualDelivery'
    },
    {
      title: t('Carrier'),
      name: 'carrierName'
    },
    {
      title: t('Last Updated'),
      name: 'lastUpdated',
      sortName: 'changedUtc'
    },
    {
      title: t('Status'),
      name: 'status'
    },
    {
      title: t('Direction'),
      name: 'direction'
    }
  ];
};

export const formatShipments = shipments =>
  shipments.map(row => {
    const shipment = {
      id: row.id,
      originZip: row.originPostalCode,
      originCity: row.originCity,
      destinationCity: row.destinationCity,
      destinationZip: row.destinationPostalCode,
      destinationLatitude: row.destinationLatitude,
      destinationLongitude: row.destinationLongitude,
      originLatitude: row.originLatitude,
      originLongitude: row.originLongitude,
      pickupDate: formatTime(row.pickupDate),
      plannedPickup: formatTime(row.plannedPickup),
      projectedPickup: formatTime(row.projectedPickup),
      actualPickup: formatTime(row.actualPickup),
      estimatedDelivery: formatTime(row.projectedDelivery),
      plannedDelivery: formatTime(row.plannedDelivery),
      projectedDelivery: formatTime(row.projectedDelivery),
      actualDelivery: formatTime(row.actualDelivery),
      deliveryDate: formatTime(row.deliveryDate),
      lastUpdated: formatTime(row.changedUtc),
      status: row.status,
      direction: row.direction,
      carrierName: row.carrierName
    };

    return shipment;
  });
export const downloadCSV = async (orgId, query) => {
  const token = localStorage.getItem('access_token');

  const protocol = JSON.parse(REACT_APP_API_SECURE) ? 'https' : 'http';
  const API_URL = `${protocol}://${REACT_APP_API}/api/Export/Shipments`;

  fetch(API_URL, {
    method: 'POST',
    headers: new Headers({
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`
    }),
    body: JSON.stringify({
      orgId: orgId,
      queryText: `FROM ShipmentSummary Select * ${query}`
    })
  })
    .then(response => response.blob())
    .then(blob => {
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'shipments.csv'; //TODO :  It was noted that this might have issues on IOS.  Feel free to revist this functionality and refactor if it is still an issue on mobile in the future.
      document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
      a.click();
      a.remove(); //afterwards we remove the element again
    });
};
